module.exports = __webpack_public_path__ + "img/utilityhydrant_driving.5f1df8bf.svg";